import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';

const deleteLabel = async (labelId: string): Promise<void> => {
  await customAxios.delete(`/labels/${labelId}`);
};

export const useDeleteLabel = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteLabel,
    onSuccess: () => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      queryClient.invalidateQueries({ queryKey: ['labels', orgId] }).catch(() => undefined);
    },
  });
};
